import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "页面不存在 - 大师兄影视",
    description: "抱歉，你访问的页面不存在或已被移除，返回大师兄影视首页继续浏览影视内容。",
  });

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-8 py-24 md:py-32 flex flex-col items-center justify-center text-center">
        <span className="font-heading text-6xl md:text-8xl font-extrabold text-primary-500/20">404</span>
        <span className="w-16 h-16 flex items-center justify-center rounded-full bg-secondary-100 mt-4 mb-5">
          <i className="ri-movie-line text-3xl text-secondary-600" />
        </span>
        <h1 className="font-heading text-xl md:text-3xl font-extrabold text-foreground-950">这个页面走丢了</h1>
        <p className="mt-2 text-sm md:text-base text-foreground-600 max-w-md">
          你要找的页面可能已被移除或地址有误，不妨回到首页，继续发现好作品。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category/全部"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-100 border border-background-200 text-foreground-800 text-sm font-semibold hover:border-primary-300 transition-colors cursor-pointer"
          >
            <i className="ri-grid-fill" />
            浏览全部影视
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}